module.exports = __webpack_public_path__ + "img/page3-4.a8062041.png";